import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PostalAddressableSchema = withDefaults({
  type: 'postal-addressable',
  fields: [
    {
      kind: 'hasMany',
      name: 'ownedPostalAddresses',
      type: 'postal-address',
      options: {
        async: false,
        inverse: 'postalAddressable',
        as: 'postal-addressable',
      },
    },
  ],
});

export default PostalAddressableSchema;
